function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1 9.665C1 8.745 1.779 8 2.74 8h14.623c.96 0 1.74.745 1.74 1.665v6.661c0 .92-.78 1.665-1.74 1.665h-5.28c-.537-1.455-1.987-2.498-3.69-2.498-1.705 0-3.154 1.043-3.692 2.498H2.74c-.96 0-1.739-.745-1.739-1.665v-6.66z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.657 9.665c.879 0 1.633.85 1.757 1.682l.13.861c.262 1.739.385 2.555.385 3.285 0 .32.01.877.023 1.445.02.928.048 1.886.048 1.886h-.94c-.641-2.61-2.193-3.33-3.914-3.33-1.722 0-2.174.416-2.174.416V9.665h4.685zm-2.076 1.25v2.913h3.044s-.107-1.89-.87-2.498c-.763-.607-2.174-.416-2.174-.416z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.102 19.163c0-1.567 1.327-2.837 2.964-2.837 1.636 0 2.963 1.27 2.963 2.837 0 1.567-1.327 2.837-2.963 2.837-1.637 0-2.964-1.27-2.964-2.837zm1.164 0c0 .952.806 1.723 1.8 1.723.993 0 1.798-.771 1.798-1.723 0-.952-.805-1.723-1.798-1.723-.994 0-1.8.771-1.8 1.723zM8.311 16.326c-1.636 0-2.963 1.27-2.963 2.837C5.348 20.73 6.675 22 8.311 22c1.637 0 2.964-1.27 2.964-2.837 0-1.567-1.327-2.837-2.964-2.837zm0 4.56c-.993 0-1.8-.771-1.8-1.723 0-.952.807-1.723 1.8-1.723.995 0 1.8.771 1.8 1.723 0 .952-.805 1.723-1.8 1.723z"
});

var SvgHeavyTruck = function SvgHeavyTruck(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "currentColor",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeavyTruck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/heavy-truck.16437e8c.svg";
export { ForwardRef as ReactComponent };